import { api } from "../lib";

export interface StainDeletionEligibility {
  eligible: boolean;
  code:
    | "eligible"
    | "signed_material"
    | "history_unknown"
    | "permission_required"
    | "locked"
    | "shipped";
  reason: string;
}

export async function getStainDeletionEligibility(
  slideId: string
): Promise<StainDeletionEligibility> {
  return api.get<StainDeletionEligibility>(
    `/workflows/slides/${slideId}/deletion-eligibility`
  );
}
